var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "max-width": _vm.breakpoint ? '480' : '664',
      "transition": "fade-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(props) {
        return [_vm._t("activator", null, null, props)];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-sheet', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "color": "content",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "dark secondary white--text"
  }, [_vm._v(" " + _vm._s(_vm.program.name) + " - " + _vm._s(_vm.number) + "회차 출석체크 "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "dark": "",
      "text": "",
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.shows = !_vm.shows;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-row', {
    staticClass: "ma-0",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-card', {
    staticClass: "fill-height",
    staticStyle: {
      "min-width": "320px",
      "min-height": "240px",
      "overflow": "hidden"
    },
    attrs: {
      "flat": "",
      "rounded": "xl"
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 1 / 1,
      "max-width": _vm.breakpoint ? undefined : 320,
      "max-height": _vm.breakpoint ? undefined : 320
    }
  }, [!_vm.isFullscreenMode ? _c('qrcode-stream-reader', _vm._b({
    on: {
      "changeCamera": function changeCamera(camera) {
        return _vm.propCamera = camera;
      }
    },
    model: {
      value: _vm.decoded,
      callback: function callback($$v) {
        _vm.decoded = $$v;
      },
      expression: "decoded"
    }
  }, 'qrcode-stream-reader', {
    propCamera: _vm.propCamera
  }, false), [_c('message-snackbar', _vm._b({
    attrs: {
      "absolute": "",
      "bottom": "",
      "tile": ""
    },
    on: {
      "close": function close($event) {
        _vm.message = null;
      }
    }
  }, 'message-snackbar', {
    message: _vm.message
  }, false)), _c('v-btn', {
    staticClass: "mb-3",
    attrs: {
      "slot": "button",
      "fab": "",
      "elevation": "4"
    },
    on: {
      "click": function click($event) {
        _vm.isFullscreenMode = !_vm.isFullscreenMode;
      }
    },
    slot: "button"
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("mdi-fullscreen")])], 1)], 1) : _vm._e()], 1)], 1)], 1), _c('v-col', {
    staticStyle: {
      "min-width": "320px",
      "min-height": "240px"
    },
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-data-table', _vm._b({
    staticClass: "fill-height rounded-xl",
    attrs: {
      "disable-filtering": "",
      "disable-pagination": "",
      "disable-sort": "",
      "hide-default-footer": "",
      "items-per-page": -1
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: "item.".concat(header.value),
        fn: function fn(_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    }), {
      key: "no-data",
      fn: function fn() {
        return [_vm._v("출석기록이 없습니다")];
      },
      proxy: true
    }], null, true)
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers
  }, false))], 1)], 1), _c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isFullscreenMode,
      expression: "isFullscreenMode"
    }],
    attrs: {
      "dark": false,
      "color": "white",
      "opacity": "1"
    }
  }, [_c('v-responsive', {
    attrs: {
      "height": "100vh",
      "width": "100vw"
    }
  }, [_vm.isFullscreenMode ? _c('qrcode-stream-reader', _vm._b({
    on: {
      "changeCamera": function changeCamera(camera) {
        return _vm.propCamera = camera;
      }
    },
    model: {
      value: _vm.decoded,
      callback: function callback($$v) {
        _vm.decoded = $$v;
      },
      expression: "decoded"
    }
  }, 'qrcode-stream-reader', {
    propCamera: _vm.propCamera
  }, false), [_c('message-snackbar', _vm._b({
    attrs: {
      "absolute": "",
      "bottom": "",
      "tile": ""
    },
    on: {
      "close": function close($event) {
        _vm.message = null;
      }
    }
  }, 'message-snackbar', {
    message: _vm.message
  }, false)), _c('v-btn', {
    staticClass: "mb-3",
    attrs: {
      "slot": "button",
      "fab": "",
      "elevation": "4"
    },
    on: {
      "click": function click($event) {
        _vm.isFullscreenMode = !_vm.isFullscreenMode;
      }
    },
    slot: "button"
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("mdi-fullscreen-exit")])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }